var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2417 14.0792C12.3096 13.3171 11.3667 12.5292 11.3667 11.3021C11.3667 9.89417 12.6712 8.9125 14.8542 8.9125C17.1533 8.9125 18.0058 10.0104 18.0833 11.625L20.9379 11.625C20.8475 9.40333 19.4912 7.3625 16.7917 6.70375V3.875L12.9167 3.875L12.9167 6.665C10.4108 7.2075 8.39583 8.835 8.39583 11.3279C8.39583 14.3117 10.8629 15.7971 14.4667 16.6625C17.6958 17.4375 18.3417 18.5742 18.3417 19.7754C18.3417 20.6667 17.7087 22.0875 14.8542 22.0875C12.1933 22.0875 11.1471 20.8992 11.005 19.375H8.16333C8.31833 22.2037 10.4367 23.7925 12.9167 24.3221V27.125H16.7917V24.3479C19.3104 23.87 21.3125 22.4104 21.3125 19.7625C21.3125 16.0942 18.1737 14.8412 15.2417 14.0792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.ee071e851fd13e6da54682c25b0b25dc.svg";
export { ForwardRef as ReactComponent };